
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto">
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Política de Privacidade</CardTitle>
            <p className="text-sm text-gray-600">Última atualização: {new Date().toLocaleDateString('pt-BR')}</p>
          </CardHeader>
          <CardContent className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Informações que Coletamos</h2>
              <p className="text-gray-700 leading-relaxed">
                Coletamos informações quando você se registra em nosso serviço, incluindo seu nome, 
                email e informações de perfil do Instagram/Facebook quando você conecta essas contas.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Como Usamos Suas Informações</h2>
              <p className="text-gray-700 leading-relaxed">
                Utilizamos suas informações para:
              </p>
              <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
                <li>Fornecer e manter nosso serviço</li>
                <li>Gerenciar sua conta e preferências</li>
                <li>Facilitar a publicação de conteúdo em suas redes sociais</li>
                <li>Melhorar nossos serviços</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Compartilhamento de Informações</h2>
              <p className="text-gray-700 leading-relaxed">
                Não vendemos, trocamos ou transferimos suas informações pessoais para terceiros, 
                exceto quando necessário para fornecer nossos serviços ou quando exigido por lei.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. Integração com Instagram/Facebook</h2>
              <p className="text-gray-700 leading-relaxed">
                Quando você conecta sua conta do Instagram/Facebook, acessamos apenas as informações 
                necessárias para publicar conteúdo em seu nome, conforme autorizado por você.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Segurança dos Dados</h2>
              <p className="text-gray-700 leading-relaxed">
                Implementamos medidas de segurança adequadas para proteger suas informações pessoais 
                contra acesso não autorizado, alteração, divulgação ou destruição.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Seus Direitos</h2>
              <p className="text-gray-700 leading-relaxed">
                Você tem o direito de acessar, corrigir ou excluir suas informações pessoais. 
                Para exercer esses direitos, entre em contato conosco.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Contato</h2>
              <p className="text-gray-700 leading-relaxed">
                Para questões sobre esta política de privacidade, entre em contato:
                <br />
                Email: colombesalexanderferreira@gmail.com
                <br />
                Website: minhagencia.digital
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
